<template>
    <div class="sdb-logo-container">
        <img :src="`${publicPath}2nomi-Logo-1.png`" alt="2nomi-Logo" class="responsive">
    </div>
</template>
<script>
export default{
  data () {
	  return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>    
<style>
.sdb-logo-container{ width: 8.5rem !important; margin: 0px 6px;}
</style>